import { Box, Card } from '@mui/material';
import { Fragment } from 'react';
import { useDocketSelectors } from 'redux/utils/selectors/docket-selectors';
import NoDataMessage from '@act/toolkit/tables/NoDataMessage';
import Loader from '../../workflows/loader';
import InteractionActivity from './interaction-activity';
import { InteractionDto } from '@act/shared/data-transfer-objects';

interface DailyActivityProps {
  interactions: InteractionDto[];
}

const DailyActivity = ({ interactions }: DailyActivityProps) => {
  const isLoading = useDocketSelectors.interactionsLoadingState() === 'loading';

  return (
    <Card sx={{ border: 'none', borderRadius: '0px' }}>
      {interactions.map(interaction => (
        <Fragment key={`${interaction.interactionId}`}>
          <InteractionActivity interaction={interaction} />
        </Fragment>
      ))}

      {!interactions.length && !isLoading && (
        <Box margin="16px 0 24px" flexShrink={0} height="fit-content">
          <NoDataMessage
            iconName="CalendarX"
            message="No activity found"
            subMessage="Try checking other dates"
          />
        </Box>
      )}

      {isLoading && <Loader />}
    </Card>
  );
};

export default DailyActivity;
